module.exports = {"130972400":"高新乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130972.json
// module id = 313
// module chunks = 0